// extracted by mini-css-extract-plugin
export default {"container":"ViewModule_container__ZVu3e"};